// Action types for the Communication / Notification settings feature

// Communication list (the events/triggers)
export const GET_COMMUNICATION_LIST = "GET_COMMUNICATION_LIST";
export const GET_COMMUNICATION_LIST_SUCCESS = "GET_COMMUNICATION_LIST_SUCCESS";
export const GET_COMMUNICATION_LIST_FAIL = "GET_COMMUNICATION_LIST_FAIL";

// Communication channel list (company-level per-channel config)
export const GET_COMMUNICATION_CHANNEL_LIST = "GET_COMMUNICATION_CHANNEL_LIST";
export const GET_COMMUNICATION_CHANNEL_LIST_SUCCESS =
  "GET_COMMUNICATION_CHANNEL_LIST_SUCCESS";
export const GET_COMMUNICATION_CHANNEL_LIST_FAIL =
  "GET_COMMUNICATION_CHANNEL_LIST_FAIL";

// Create communication channel
export const CREATE_COMMUNICATION_CHANNEL = "CREATE_COMMUNICATION_CHANNEL";
export const CREATE_COMMUNICATION_CHANNEL_SUCCESS =
  "CREATE_COMMUNICATION_CHANNEL_SUCCESS";
export const CREATE_COMMUNICATION_CHANNEL_FAIL =
  "CREATE_COMMUNICATION_CHANNEL_FAIL";

// Update communication channel
export const UPDATE_COMMUNICATION_CHANNEL = "UPDATE_COMMUNICATION_CHANNEL";
export const UPDATE_COMMUNICATION_CHANNEL_SUCCESS =
  "UPDATE_COMMUNICATION_CHANNEL_SUCCESS";
export const UPDATE_COMMUNICATION_CHANNEL_FAIL =
  "UPDATE_COMMUNICATION_CHANNEL_FAIL";

// Communication placeholder list (the {{Token}} variables a comm exposes)
export const GET_COMMUNICATION_PLACEHOLDER_LIST =
  "GET_COMMUNICATION_PLACEHOLDER_LIST";
export const GET_COMMUNICATION_PLACEHOLDER_LIST_SUCCESS =
  "GET_COMMUNICATION_PLACEHOLDER_LIST_SUCCESS";
export const GET_COMMUNICATION_PLACEHOLDER_LIST_FAIL =
  "GET_COMMUNICATION_PLACEHOLDER_LIST_FAIL";

// Notification (in-app) template list
export const GET_NOTIFICATION_TEMPLATE_LIST = "GET_NOTIFICATION_TEMPLATE_LIST";
export const GET_NOTIFICATION_TEMPLATE_LIST_SUCCESS =
  "GET_NOTIFICATION_TEMPLATE_LIST_SUCCESS";
export const GET_NOTIFICATION_TEMPLATE_LIST_FAIL =
  "GET_NOTIFICATION_TEMPLATE_LIST_FAIL";
